import React, {FunctionComponent} from 'react';
import styles from './BarChart.module.css';
import {DataGroup} from "../../models/visualisation-data.interface";
import BarChartBar from "../bar-chart-bar/BarChartBar";

const BarChart: FunctionComponent<{dataGroup: DataGroup[]}> = (
  {
    dataGroup,
  }) => {

  return (
    <div className={styles.container}>
      {Object.entries(dataGroup[1])
        .map(([title, val], i) =>
          <BarChartBar title={title} values={val} key={i} oldValues={Object.entries(dataGroup[0])[i]}/>
        )
      }
    </div>
  );
}

export default BarChart;
